export interface StickerCategory {
  abbreviation: string;
  name: string;
  color?: string;
  quantityOfStickers: number;
  stickers?: Sticker[];
  startsAtZero?: boolean;
}
export interface Sticker {
  albumId: string;
  categoryAbbreviation: string;
  number: string;
  quantity: number;
}

export interface UserWithStickers {
  id: string;
  name: string;
  cityId: string;
  stickers: Sticker[];
  missingStickerIds: string[];
  repeatedStickerIds: string[];
  quantityOfMatches?: number;
}

export interface UserWithStickersJSON {
  name: string;
  city_id: string;
  state_id: string;
  stickers: Sticker[];
  missing: string[];
  repeated: string[];
}

export function stickerToStickerId(s: Sticker): string {
  return `${s.albumId}|${s.categoryAbbreviation}|${s.number}`;
}

export function stickerIdToSticker(id: string): Sticker {
  const [albumId, categoryAbbreviation, number] = id.split("|");
  return {
    albumId,
    categoryAbbreviation,
    number,
    quantity: 0,
  };
}

export function getRepeatedStickerIds(stickers: Sticker[]): string[] {
  return stickers
    .filter((it) => it.quantity > 1)
    .map((it) => stickerToStickerId(it));
}

export function getMissingStickerIds(stickers: Sticker[]): string[] {
  return stickers
    .filter((it) => it.quantity === 0)
    .map((it) => stickerToStickerId(it));
}
